<template>
  <b-card style="padding:40px;">
    <h5><b>UPDATE PRODUCT</b></h5>
    <hr />
    <b-container md="12">
      <center>
        <b-row>
          <b-col md="12">
            <b-img v-bind="mainProps" thumbnail fluid :src="this.form.img" />
          </b-col>
        </b-row>
      </center>
    </b-container>
    <br />
    <b-row>
      <b-col md="6">
        <b-form-group>
          <label :for="`input-name`">Name</label>
          <b-form-input
            v-model="form.name"
            :id="`input-name`"
            :type="`text`"
            class="input-new"
          ></b-form-input>
          <p v-if="error.name">
            <span class="danger-new">{{ this.error.name }}</span>
          </p>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label :for="`input-size`">Size</label>
          <b-form-input
            v-model="form.size"
            :id="`input-size`"
            :type="`text`"
            class="input-new"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="6">
        <b-form-group>
          <label :for="`input-size`">Type</label>
          <b-form-select
            v-model="form.proCat"
            :options="select.proCat"
            class="input-new"
            required
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label :for="`input-size`">Volume (ml)</label>
          <b-form-input
            v-model="form.volume"
            :id="`input-size`"
            :type="`number`"
            class="input-new"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row align="right">
      <b-col>
        <b-form-file v-model="form.image" class="mt-3" plain></b-form-file>
      </b-col>
    </b-row>
    <br />
    <b-row align="right">
      <b-col>
        <b-button variant="primary" size="sm" @click="onClickBack">
          BACK </b-button
        >&nbsp;&nbsp;&nbsp;
        <b-button variant="primary" size="sm" @click="onClickUpdate"
          >UPDATE</b-button
        >
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: "",
        size: "",
        img: null,
        image: null,
        proCat: "",
        volume: ""
      },

      select: {
        proCat: [
          { text: "UHT", value: "1" },
          { text: "Pasteurized", value: "2" }
        ]
      },

      mainProps: { width: 400, height: 400, class: "m1" },
      error: {
        name: ""
      }
    };
  },
  created() {
    this.showProduct();
  },
  methods: {
    onClickBack() {
      this.$router.push({
        path: `product?filter=${this.$route.query.filter}&page=${this.$route.query.page}&name=${this.$route.query.name}`
      });
    },
    showProduct() {
      this.$store
        .dispatch("showProduct", {
          product_id: this.$route.query.id
        })
        .then(res => {
          if (res.data.response.code === 100) {
            this.form.id = this.$route.query.id;
            this.form.name = res.data.data.name;
            this.form.size = res.data.data.size;
            this.form.proCat = String(res.data.data.type);
            this.form.volume = res.data.data.milliliter;
            // this.form.img = "https://azizazri.com/" + res.data.data.path;
            this.form.img =
              `${process.env.VUE_APP_BASE_URL}/` + res.data.data.path;
          }
        });
    },
    onClickUpdate() {
      this.checkForm();
      let form = new FormData();
      form.set("product_id", this.form.id);
      form.set("name", this.form.name);
      form.set("size", this.form.size);
      if (this.form.image !== null) {
        form.set("milliliter", this.form.volume);
      } else {
        form.set("milliliter", "");
      }
      form.set("type", parseInt(this.form.proCat));
      if (this.form.image !== null) {
        form.set("image", this.form.image);
      }

      this.$store.dispatch("createProduct", form).then(res => {
        if (res.data.response.code === 1) {
          this.$router.push({
            path: `product?filter=${this.$route.query.filter}&page=${this.$route.query.page}&name=${this.$route.query.name}`
          });
        }
      });
    },

    // Check form
    checkForm: function(e) {
      if (this.form.name) return true;
      this.error.name = "";
      if (!this.form.name) this.error.name = "Name required.";
      e.preventDefault();
    }
  }
};
</script>
<style lang="css" scoped></style>
